import '../../../../../stylesheets/nav/profile-popover.css'


const SubscriptionButtons = ( { subscription } ) => {

    return (
        <div className="subscription-buttons-content-container">

            {/* Main Col 1 of 3 of Parent display: grid - Outer only for now since no inner yet - Left Margin PlaceHolder */}
            <div className="main-column-one"></div>

            {/* Main Col 2 of 3: Outer and Inner Together in Single Class (to practice this since we practiced seperating outer and inner into seperate divs above) */}
            <div className="main-column-two buttons">
                { subscription.paymentStatus && <div className="main-column-two-buttons left-col"> Cancel:          </div> }
                { subscription.paymentStatus && <div className="main-column-two-buttons right-col"> Email to Cancel </div> }
            </div>

            {/* Main Col 3 of 3: Outer - Right Margin PlaceHolder */}   
            <div className="main-column-three"></div>
        </div>
    )
}

export default SubscriptionButtons